var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInquiryImg21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2955 18.7784C64.2955 18.7784 57.321 18.6318 51.2079 20.6701C45.4984 15 30.9834 15 30.9834 15V23.2705L31.0572 23.383C34.3796 24.8592 36.6929 28.1635 36.6929 32.0103H53.8215H63.3406C65.0092 25.7439 64.2905 18.7784 64.2905 18.7784H64.2955Z",
    fill: "#D8E1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7733 22.6934C28.7438 22.6885 28.7143 22.6836 28.6798 22.6787C28.7093 22.6787 28.7389 22.6885 28.7733 22.6934Z",
    fill: "#D8E1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.301 22.6304C28.2616 22.6304 28.2222 22.6206 28.1877 22.6157C28.2271 22.6157 28.2665 22.6255 28.301 22.6304Z",
    fill: "#D8E1F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8037 22.5811C27.7643 22.5811 27.725 22.5762 27.6807 22.5713C27.72 22.5713 27.7594 22.5762 27.8037 22.5811Z",
    fill: "#D8E1F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2409 22.7866C29.2409 22.7866 29.1966 22.7769 29.1769 22.772C29.1966 22.772 29.2212 22.7817 29.2409 22.7866Z",
    fill: "#D8E1F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7044 22.8991C29.7044 22.8991 29.6793 22.8941 29.6643 22.8892C29.6793 22.8892 29.6893 22.8941 29.7044 22.8991Z",
    fill: "#D8E1F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.158 23.0362C30.158 23.0362 30.1471 23.0362 30.1417 23.0308C30.1471 23.0308 30.1525 23.0308 30.158 23.0362Z",
    fill: "#D8E1F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32C11 44.468 18.6143 56.4735 30.0334 59.2825V63.0604C30.0334 63.5813 30.4616 64 30.9833 64H50.0167C50.5433 64 50.9666 63.5764 50.9666 63.0604V59.2825C62.3857 56.4735 70 44.468 70 32H11Z",
    fill: "#F8FBFF",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6594 32.0101C17.6594 26.7897 21.9219 22.5566 27.1786 22.5566C32.4353 22.5566 36.6977 26.7897 36.6977 32.0101",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1786 27.2886V28.9407",
    stroke: "#B2BAD1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2729 29.3169L31.2245 30.358",
    stroke: "#B2BAD1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0844 29.3169L23.1327 30.358",
    stroke: "#B2BAD1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20.8605C57.0896 18.8582 63.8466 19.0023 63.8466 19.0023C63.8466 19.0023 64.563 25.8444 62.8995 32",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8264 32.0103C55.0864 29.0286 54.9388 24.6099 50.9716 20.6701C45.2621 15 30.9834 15 30.9834 15V23.2705",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4115 22.0879L45.9758 30.5931",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1211 22.0879V27.758",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_805)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiryImg21);
export default __webpack_public_path__ + "static/media/inquiry_img21.572ddd5d22588aeb3e23e311a601ef45.svg";
export { ForwardRef as ReactComponent };